module.exports = __webpack_public_path__ + "media/fonts/Oricons-028b74c51fe5935f3df6432ffef033cc.svg";